/***********************************************************************************
 * Entry for client side
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import { createApp } from './App';

const { app, router, store } = createApp();

if ((window as any).__INITIAL_STATE__) {
    store.replaceState((window as any).__INITIAL_STATE__);
}

router.onReady(
    (): void => {
        app.$mount('#app');
    }
);
